module.exports = __webpack_public_path__ + "static/media/appadverthand.856a6f85.svg";